import { render } from "./Bracket.vue?vue&type=template&id=1eab81fe"
import script from "./Bracket.vue?vue&type=script&lang=js"
export * from "./Bracket.vue?vue&type=script&lang=js"

import "./Bracket.vue?vue&type=style&index=0&id=1eab81fe&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__